import React from "react";

interface Star1Props {
  width?: number;
  height?: number;
  className?: string;
  opacity?: number;
}

const Star1: React.FC<Star1Props> = ({
  width = 1138,
  height = 868,
  className,
  opacity = 0.5,
}) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        opacity={opacity}
        d="M553.578 1018.34C560.905 1030.15 578.092 1030.15 585.419 1018.34L692.075 846.382C696.892 838.616 706.609 835.458 715.071 838.91L902.431 915.336C915.302 920.586 929.207 910.484 928.191 896.62L913.403 694.813C912.735 685.699 918.741 677.433 927.616 675.251L1124.12 626.954C1137.61 623.636 1142.93 607.29 1133.95 596.671L1003.37 442.098C997.474 435.117 997.474 424.899 1003.37 417.918L1133.95 263.345C1142.93 252.726 1137.61 236.38 1124.12 233.062L927.616 184.764C918.741 182.583 912.735 174.317 913.403 165.202L928.191 -36.6046C929.207 -50.468 915.302 -60.5707 902.431 -55.3204L715.071 21.1056C706.609 24.5573 696.892 21.3998 692.075 13.6335L585.419 -158.324C578.092 -170.137 560.905 -170.137 553.578 -158.324L446.922 13.6335C442.105 21.3998 432.388 24.5573 423.926 21.1056L236.566 -55.3204C223.695 -60.5706 209.79 -50.468 210.806 -36.6046L225.594 165.202C226.262 174.317 220.256 182.583 211.381 184.764L14.8816 233.062C1.38274 236.38 -3.92851 252.726 5.04208 263.345L135.625 417.918C141.523 424.899 141.523 435.117 135.625 442.098L5.0421 596.671C-3.9285 607.29 1.38272 623.636 14.8816 626.954L211.381 675.251C220.256 677.433 226.262 685.699 225.594 694.813L210.806 896.62C209.79 910.484 223.695 920.586 236.566 915.336L423.926 838.91C432.388 835.458 442.105 838.616 446.922 846.382L553.578 1018.34Z"
        fill="url(#paint0_radial_890_24583)"
      />
      <defs>
        <radialGradient id="paint0_radial_890_24583" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(569.499 430.008) rotate(-90) scale(614)">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.814095" stopColor="white" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default Star1;
